<ng-container
    *ngIf="
        data.from === 'chat' ||
        data.from === 'activity' ||
        data.from === 'incorrect-messages'
    "
>
    <div
        class="w-full max-w-full"
        [dir]="lang === 'en' ? 'ltr' : 'rtl'"
    >
        <ng-container *transloco="let t">
            <div class="slider-container">
                <div class="slider-content" *ngIf="queries.length > 0">
                    <div
                        class="slide"
                        *ngFor="let query of queries; let i = index"
                        [class.active]="i === currentIndex"
                    >
                        <div class="px-2 pt-4 rounded-lg w-full">
                            <ng-container *ngIf="isTracker; else noTraker">
                                <form
                                    [formGroup]="secondFormGroup"
                                    class="flex w-full justify-start flex-wrap gap-4 min-h-[30dvh] pt-1 md:pt-1"
                                >
                                    <ng-container *ngIf="typeList.length > 0">
                                        <div class="w-full md:w-[48%]">
                                            <mat-select-search
                                                [width]="'w-full'"
                                                [options]="typeList"
                                                [placeholder]="
                                                    'Set Schedule for your tracker'
                                                "
                                                [label]="'Set Tracker Type'"
                                                [multiple]="false"
                                                [searchPlaceholder]="''"
                                                [displayField]="'value'"
                                                [valueField]="'id'"
                                                [formControl]="typeCtrl"
                                                (selectionChange)="
                                                    onSelectType($event)
                                                "
                                            >
                                            </mat-select-search>
                                        </div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="scheduleList.length > 0"
                                    >
                                        <div class="w-full md:w-[48%]">
                                            <mat-select-search
                                                [width]="'w-full'"
                                                [options]="scheduleList"
                                                [placeholder]="
                                                    'Set Period for your tracker'
                                                "
                                                [label]="'Set Period'"
                                                [multiple]="false"
                                                [searchPlaceholder]="''"
                                                [displayField]="'value'"
                                                [valueField]="'id'"
                                                [formControl]="scheduleCtrl"
                                                (selectionChange)="
                                                    onSelectSchedule($event)
                                                "
                                            >
                                            </mat-select-search>
                                        </div>
                                    </ng-container>

                                    <div class="w-full md:w-[48%]">
                                        <mat-form-field class="w-full relative fuse-mat-dense">
                                            <mat-label>{{ t('Threshold') }}</mat-label>
                                            <input
                                                matInput
                                                type="number"
                                                [formControlName]="'threshold'"
                                            />
                                        </mat-form-field>
                                    </div>

                                    <div class="w-full md:w-[48%]">
                                        <mat-form-field class="w-full relative fuse-mat-dense">
                                            <mat-label
                                                >{{ t('Threshold Type') }}</mat-label
                                            >
                                            <mat-select
                                                [formControlName]="
                                                    'thresholdType'
                                                "
                                                [placeholder]="t('Select If the danger value will be above or below threshold')"
                                            >
                                                <mat-option [value]="'max'">
                                                    {{ t('Max') }}
                                                </mat-option>
                                                <mat-option [value]="'min'">
                                                    {{ t('Min') }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <mat-form-field
                                        class="w-full relative mt-8 fuse-mat-dense"
                                        [subscriptSizing]="'dynamic'"
                                    >
                                        <mat-label>{{
                                            t("Generated Query")
                                        }}</mat-label>
                                        <textarea
                                            matInput
                                            #descriptionField
                                            [formControlName]="'generatedQuery'"
                                            maxlength="20000"
                                            [placeholder]="
                                                t(
                                                    'Generated Query based on choosen data soure, table, and your question'
                                                )
                                            "
                                            [rows]="6"
                                            [spellcheck]="true"
                                            cdkTextareaAutosize
                                            cdkAutosizeMaxRows="6"
                                            class="pr-10"
                                        ></textarea>
                                        <mat-hint align="end"
                                            >{{
                                                secondFormGroup.get(
                                                    "generatedQuery"
                                                ).value?.length || 0
                                            }}/20000</mat-hint
                                        >
                                        <button
                                            type="button"
                                            (click)="executeQuery()"
                                            class="absolute right-2 bottom-2 bg-primary text-md px-2 py-1 rounded-lg shadow-md hover:shadow-2xl focus:outline-none"
                                        >
                                            {{ t('Execute Query') }}
                                        </button>
                                    </mat-form-field>
                                </form>
                            </ng-container>
                            <ng-template #noTraker>
                                <p
                                    class="message-chart-meta text-start text-lg font-normal text-gray-500 dark:text-gray-400 leading-4 mb-2 break-words"
                                >
                                    <span
                                        class="text-xl font-semibold text-gray-600 dark:text-gray-300 leading-4"
                                        >{{
                                            t(
                                                "Source Table: "
                                            )
                                        }}</span
                                    >
                                    {{ query.tableName }}
                                </p>
                                <p
                                    class="message-chart-meta text-start text-lg font-normal text-gray-500 dark:text-gray-400 leading-6 mb-4 break-words"
                                >
                                    <span
                                        class="text-xl font-semibold text-gray-600 dark:text-gray-300 leading-6"
                                        >{{
                                            t(
                                                "SQL Query: "
                                            )
                                        }}</span
                                    >
                                    <ng-container
                                        *ngIf="isQueryLong(query.query)"
                                    >
                                        <ng-container
                                            *ngIf="
                                                isQueryExpanded(i);
                                                else truncatedQuery
                                            "
                                        >
                                            {{ query.query }}
                                            <button
                                                type="button"
                                                (click)="toggleQueryExpanded(i)"
                                                class="text-primary cursor-pointer ml-1 underline hover:no-underline"
                                            >
                                                {{ t("see less") }}
                                            </button>
                                        </ng-container>
                                        <ng-template #truncatedQuery>
                                            {{ query.query | truncate: 150 }}
                                            <button
                                                type="button"
                                                (click)="toggleQueryExpanded(i)"
                                                class="text-primary cursor-pointer ml-1 underline hover:no-underline"
                                            >
                                                {{ t("see more") }}
                                            </button>
                                        </ng-template>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="!isQueryLong(query.query)"
                                    >
                                        {{ query.query }}
                                    </ng-container>
                                </p>
                            </ng-template>

                            <div
                                *ngIf="query.chartsList?.length"
                                class="flex flex-col w-full gap-8 mt-2"
                            >
                                <div
                                    *ngFor="
                                        let chart of query.chartsList;
                                        let ci = index
                                    "
                                    class="flex flex-col w-full min-h-0"
                                >
                                    <div
                                        *ngIf="!isTracker"
                                        class="relative flex items-center justify-center mb-3 min-h-[2.5rem] px-1"
                                    >
                                        <button
                                            *ngIf="showCreateTrackerButton()"
                                            mat-icon-button
                                            type="button"
                                            (click)="
                                                openCreateTrackerDialog(
                                                    query,
                                                    chart
                                                )
                                            "
                                            [matTooltip]="
                                                t('Create tracker from chart')
                                            "
                                            class="message-chart-icon-btn absolute start-0 top-1/2 -translate-y-1/2 shrink-0 text-gray-500 dark:text-gray-400 hover:text-primary"
                                        >
                                            <mat-icon [svgIcon]="'heroicons_outline:presentation-chart-bar'"></mat-icon>
                                        </button>
                                        <h2
                                            class="message-chart-title w-full text-center text-xl md:text-2xl font-semibold text-gray-600 dark:text-gray-200 leading-snug break-words"
                                            [class.pl-12]="showCreateTrackerButton()"
                                            [class.pr-12]="canFavoriteChart()"
                                        >
                                            {{ getChartDisplayTitle(chart) }}
                                        </h2>
                                        <button
                                            *ngIf="canFavoriteChart()"
                                            mat-icon-button
                                            type="button"
                                            (click)="
                                                toggleFavorite(query, i, chart)
                                            "
                                            [matTooltip]="
                                                chart.favorite
                                                    ? t('Remove from favorites')
                                                    : t('Add to favorite')
                                            "
                                            class="message-chart-icon-btn absolute end-0 top-1/2 -translate-y-1/2 shrink-0 text-gray-400 dark:text-gray-500 hover:text-amber-400"
                                            [attr.aria-pressed]="chart.favorite"
                                        >
                                            <mat-icon
                                                [class.text-amber-400]="
                                                    chart.favorite
                                                "
                                            >
                                                {{
                                                    chart.favorite
                                                        ? "star"
                                                        : "star_border"
                                                }}
                                            </mat-icon>
                                        </button>
                                    </div>
                                    <div
                                        class="message-chart-card flex flex-col flex-auto w-full py-1 px-0.5 sm:px-2 sm:py-2 bg-card shadow rounded-2xl overflow-visible"
                                    >
                                        <app-dynamic-charts
                                            [chartData]="chart"
                                            [chartTitle]="
                                                getChartTitleForDynamic(chart)
                                            "
                                            [hideTitle]="true"
                                            [currentIndex]="currentIndex"
                                            [from]="'chat'"
                                            [initDelayMs]="ci * 75"
                                            (expandChartEvent)="
                                                expandChart($event, query)
                                            "
                                        ></app-dynamic-charts>
                                    </div>
                                </div>
                            </div>
                            <ng-container
                                *ngIf="isTracker; else noTrackerButton"
                            >
                                <div class="w-full mt-4 flex gap-2 justify-end">
                                    <button
                                        class="w-full sm:w-auto px-4 bg-primary"
                                        mat-flat-button
                                        type="button"
                                        (click)="cancelTracker()"
                                    >
                                        <mat-icon
                                            [svgIcon]="
                                                'heroicons_outline:x-mark'
                                            "
                                        ></mat-icon>
                                        <span>{{ t("Cancel") }}</span>
                                    </button>
                                    <button
                                        class="w-full sm:w-auto px-4 bg-primary"
                                        mat-flat-button
                                        type="button"
                                        (click)="createTracker(query)"
                                    >
                                        <mat-icon
                                            [svgIcon]="'heroicons_outline:plus'"
                                        ></mat-icon>
                                        <span>{{ t("Create Tracker") }}</span>
                                    </button>
                                </div>
                            </ng-container>
                            <ng-template #noTrackerButton>
                                <!-- <div class="w-full mt-4 flex justify-end">
                                    <button class="w-full sm:w-auto px-4 bg-primary" mat-flat-button type="button"
                                        (click)="makeItTracker(query)">
                                        <mat-icon [svgIcon]="'heroicons_outline:document-chart-bar'"></mat-icon>
                                        <span>Convert to Tracker</span>
                                    </button>
                                </div> -->
                            </ng-template>
                        </div>
                    </div>
                </div>

                <div
                    *ngIf="queries.length > 1"
                    [dir]="lang === 'ar' ? 'rtl' : 'ltr'"
                    class="slider-controls"
                >
                    <button
                        mat-icon-button
                        (click)="prevSlide()"
                        [disabled]="currentIndex === 0"
                    >
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    <span>{{ currentIndex + 1 }} / {{ queries.length }}</span>
                    <button
                        mat-icon-button
                        (click)="nextSlide()"
                        [disabled]="currentIndex === queries.length - 1"
                    >
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
</ng-container>
